package nl.volleyplanner.web.base.component

import kotlinx.coroutines.flow.StateFlow
import kotlinx.html.TagConsumer
import nl.volleyplanner.web.base.HTMLComponent
import org.w3c.dom.HTMLElement

class StateListenerContentComponent<T>(
    val stateFlow: StateFlow<T>,
    val block: TagConsumer<HTMLElement>.(T) -> HTMLElement
) : HTMLComponent() {
    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        return block.invoke(consumer, stateFlow.value)
    }

    override suspend fun getState() = stateFlow
}